import React, { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

interface OnboardingLayoutProps {
  title: string;
  body: string;
  children?: ReactNode;
  primaryLabel: string;
  onPrimaryPress: () => void;
  primaryLoading?: boolean;
  primaryDisabled?: boolean;
  secondaryLabel?: string;
  onSecondaryPress?: () => void;
  tertiaryLabel?: string;
  onTertiaryPress?: () => void;
  skipLabel?: string;
  onSkipPress?: () => void;
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  title,
  body,
  children,
  primaryLabel,
  onPrimaryPress,
  primaryLoading = false,
  primaryDisabled = false,
  secondaryLabel,
  onSecondaryPress,
  tertiaryLabel,
  onTertiaryPress,
  skipLabel,
  onSkipPress,
}) => {
  return (
    <div className="min-h-screen bg-dark-950 flex flex-col">
      <div className="flex-1 px-6 py-10 max-w-lg mx-auto w-full">
        <h1 className="text-3xl font-bold text-white leading-tight mb-4">{title}</h1>
        <p className="text-dark-300 text-base leading-relaxed">{body}</p>
        {children}
      </div>

      <div className="px-6 pb-8 pt-4 max-w-lg mx-auto w-full space-y-3">
        <button
          type="button"
          onClick={onPrimaryPress}
          disabled={primaryLoading || primaryDisabled}
          className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-onPrimary font-semibold rounded-lg transition-colors flex items-center justify-center min-h-[48px]"
        >
          {primaryLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : primaryLabel}
        </button>

        {secondaryLabel && onSecondaryPress && (
          <button
            type="button"
            onClick={onSecondaryPress}
            className="w-full py-3 px-4 bg-dark-800 hover:bg-dark-700 text-white font-medium rounded-lg border border-dark-700 transition-colors"
          >
            {secondaryLabel}
          </button>
        )}

        {tertiaryLabel && onTertiaryPress && (
          <button
            type="button"
            onClick={onTertiaryPress}
            className="w-full py-2.5 px-4 text-dark-300 hover:text-white font-medium transition-colors"
          >
            {tertiaryLabel}
          </button>
        )}

        {skipLabel && onSkipPress && (
          <button
            type="button"
            onClick={onSkipPress}
            className="w-full py-2 text-dark-500 hover:text-dark-300 text-sm transition-colors"
          >
            {skipLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default OnboardingLayout;
